import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePlatformAppsQuery = createQueryHook(PlatformAppsApiClient.getPlatformApps, {
  queryKey: ['platformApps'],
})
